import { InsuranceEntryState, insuranceMachine } from 'domains/signup/insurance/insuranceMachine';
import { isArray } from 'lodash';
import { createActorContextFromActor } from 'utils/xstate/context';

export const InsuranceContext = createActorContextFromActor<typeof insuranceMachine>();

export const withInsuranceMachineState = (
  Component: React.FC,
  matchingState: InsuranceEntryState | InsuranceEntryState[],
) => {
  return (props: Record<string, unknown>) => {
    const matchesState = InsuranceContext.useSelector(state => {
      if (isArray(matchingState) && matchingState.some(s => state.matches(s))) {
        return true;
      }

      if (state.matches(matchingState as InsuranceEntryState)) {
        return true;
      }

      return false;
    });

    if (matchesState) {
      return <Component {...props} />;
    }
    return null;
  };
};
